import React, {useEffect} from 'react';
import {Col, Row, Container} from 'reactstrap';
import './warningMessage.scss';
import attentionIcon from './icons/attention/attention.svg';
const WarningMessageComponent = (props) => {
  useEffect(() => {
    if (props.gaReport) {
      props.gaReport();
    }
  }, []);

  return (
    <Container className={`abroad-warning-message ${props?.packageData?.textUnderPackage ? 'family': ''} ${props.isBusiness ? 'isBusiness' : ''}`} style={{backgroundImage: attentionIcon.bg() }}>
      <div className='d-block font-16 text-right'>
        <span className='font-weight-bold'> רגע, זה חשוב - </span>
        {props.unsupportedCountries?.length > 0 && (
          <span>
            {' '}
            החבילה לא כוללת את
            {props.unsupportedCountries.length > 1 && <span> המדינות: </span>}
            {props.unsupportedCountries.map((country, index) => {
              return (
                <span className={`ml-1 font-weight-bold d-inline-block ${index == 0 ? 'mr-1' : ''}`} key={index}>
                  <span>
                    <bdi>{country.countryHebName}</bdi>
                  </span>
                  {index < props.unsupportedCountries.length - 1 ? ',' : ''}
                </span>
              );
            })}
            {!props.isSuitableDates && <span>ומסתיימת לפני התאריך שבחרתם </span>}
          </span>
        )}

        {(!props.unsupportedCountries || props.unsupportedCountries?.length === 0) && !props.isSuitableDates && (
          <span>החבילה מסתיימת לפני התאריך שבחרתם</span>
        )}
      </div>
    </Container>
  );
};

export default WarningMessageComponent;
